module.exports = __webpack_public_path__ + "static/img/txt_q3.c37b199.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/txt_q3.svg
// module id = 19
// module chunks = 0